import React from 'react';

type SliderStateType = { open: boolean; activeTab: string };
type SliderActionsType =
  | { type: 'toggle' }
  | { type: 'switch-tab'; tab: string; keepOpen?: boolean }
  | { type: 'open' }
  | { type: 'close' };

const sliderReducer = (state: SliderStateType, action: SliderActionsType) => {
  switch (action.type) {
    case 'toggle':
      return { ...state, open: !state.open };
    case 'open':
      return { ...state, open: true };
    case 'close':
      return { ...state, open: false };
    case 'switch-tab':
      if (state.activeTab === action.tab && !action?.keepOpen && state.open) {
        return { ...state, open: false };
      }
      return { open: true, activeTab: action.tab };
    default:
      return state;
  }
};

export const ERRORS_TAB_ID = 'spreadsheet-error-tab' as const;

export const useSliderState = (initialState: SliderStateType) => {
  const [{ open, activeTab }, dispatch] = React.useReducer(sliderReducer, initialState);

  return {
    open,
    activeTab,
    toggleOpen: () => dispatch({ type: 'toggle' }),
    openSlider: () => dispatch({ type: 'open' }),
    closeSlider: () => dispatch({ type: 'close' }),
    switchTab: (tab: string, keepOpen?: boolean) => dispatch({ type: 'switch-tab', tab, keepOpen }),
  };
};
